// extracted by mini-css-extract-plugin
export var footer = "_ns-5";
export var fulfillmentInput = "_ns-0";
export var shipDateInput = "_ns-1";
export var shipmentModal = "_ns-2";
export var shipmentModalContent = "_ns-3";
export var tableContainer = "_ns-4";